import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { useAuth } from '../context/AuthContext'
import axios from 'axios'
import { saveUserTimezone } from '../utils/dateUtils'

const AuthCallback = () => {
  const navigate = useNavigate()
  const { updateUser } = useAuth()

  useEffect(() => {
    // Handle the OAuth callback
    supabase.auth.getSession().then(async ({ data: { session }, error }) => {
      if (error) {
        console.error('AuthCallback: Error during auth callback:', error)
        navigate('/login')
        return
      }

      if (session) {
        // Sync user with backend database
        try {
          // Check for pending verification token from signup flow
          const pendingVerificationToken = localStorage.getItem('pendingVerificationToken');
          console.log('AuthCallback: pendingVerificationToken exists?', !!pendingVerificationToken);
          console.log('AuthCallback: verificationToken exists?', !!localStorage.getItem('verificationToken'));

          const syncResponse = await axios.post(
            `${process.env.REACT_APP_API_URL || 'http://localhost:5000/api'}/auth/oauth/sync`,
            {
              verification_token: pendingVerificationToken || undefined
            },
            {
              headers: {
                Authorization: `Bearer ${session.access_token}`
              }
            }
          )

          // Clear pending verification token after successful sync
          if (pendingVerificationToken) {
            localStorage.removeItem('pendingVerificationToken');
            // Also clear the main verification token
            localStorage.removeItem('verificationToken');
          }

          // Store the JWT token and user info in localStorage
          if (syncResponse.data.access_token) {
            localStorage.setItem('token', syncResponse.data.access_token)
          }

          if (syncResponse.data.user) {
            localStorage.setItem('user', JSON.stringify(syncResponse.data.user))
            // Save timezone for date formatting throughout the app
            if (syncResponse.data.user.timezone) {
              saveUserTimezone(syncResponse.data.user.timezone)
            }
            // Also update the AuthContext state immediately
            updateUser(syncResponse.data.user)
          }

          // Redirect based on user role
          const userData = syncResponse.data.user

          if (userData?.role === 'advisor') {
            navigate('/advisor')
          } else {
            navigate('/dashboard')
          }
        } catch (syncError) {
          console.error('AuthCallback: Failed to sync user:', syncError)
          console.error('AuthCallback: Error response:', syncError.response?.data)
          console.error('AuthCallback: Error status:', syncError.response?.status)

          // If it's a verification token error for new signups, redirect back to verification
          if (syncError.response?.status === 400 && syncError.response?.data?.error?.includes('Verification token')) {
            alert('Activation code verification expired. Please verify your code again.');
            localStorage.removeItem('pendingVerificationToken');
            localStorage.removeItem('verificationToken');
            navigate('/signup/verify-code');
            return;
          }

          // If sync fails for existing users, try to navigate to dashboard anyway
          navigate('/dashboard')
        }
      } else {
        navigate('/login')
      }
    })
  }, [navigate])

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh'
    }}>
      <div>
        <h2>Completing sign in...</h2>
        <p>Please wait while we redirect you.</p>
      </div>
    </div>
  )
}

export default AuthCallback
